'use client';

import {
  BreakoutSectionContainer,
  SectionRoot,
  breakoutSectionWidthBreakpoint,
  containerPaddingRem,
  sectionContainerMockPadding,
  sectionContainerWithPaddingBreakpoint,
} from '@exploration/shared-components';
import { Badge } from '@midwest/web/indicators';
import { desktop, tablet } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import Image from 'next/image';
import styled from 'styled-components';

// --------------------------------------------------------------------------

export const HeroStyles = {
  Section: styled(SectionRoot)`
    overflow: hidden;
    position: relative;
    padding-top: 2rem;

    background-image: ${({ theme }) =>
      `linear-gradient(to right, 
          ${theme.midwestColors.backgroundSecondary} 0%, 
          ${theme.midwestColors.white} 55%)`};

    ${tablet} {
      padding-top: 0;

      background-image: ${({ theme }) =>
        `linear-gradient(to right, 
            ${theme.midwestColors.backgroundSecondary} 0%, 
            ${theme.midwestColors.white} 55%,
            ${theme.midwestColors.backgroundSecondary} 100%)`};
    }
  `,

  Container: styled(BreakoutSectionContainer)`
    position: relative;
    overflow: hidden;
    padding-inline: 0;

    ${tablet} {
      flex-direction: row;
      justify-content: space-between;
    }

    ${sectionContainerWithPaddingBreakpoint} {
      padding-left: ${sectionContainerMockPadding};
    }

    ${breakoutSectionWidthBreakpoint} {
      padding-left: 24.5rem;
    }
  `,

  Title: styled(MDSText.HeroLg)``,

  ImageContainer: styled.div`
    position: relative;
    margin-top: 1rem;
    background: ${(p) => p.theme.midwestColors.neutralLightStrong};
    aspect-ratio: 1.3 / 1;
    margin-inline: -${containerPaddingRem};
    @supports not (aspect-ratio: 1.3 / 1) {
      height: 16.75rem;
    }

    ${tablet} {
      margin: 0;
      margin-right: -1rem;
      flex-grow: 0.5;
    }

    ${desktop} {
      margin: 0;
      aspect-ratio: unset;
    }
  `,

  Image: styled(Image)`
    object-fit: cover;
    height: 100%;
    width: 100%;
  `,

  Content: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    width: 100%;
    padding-inline: ${containerPaddingRem}rem;

    ${tablet} {
      padding: 3.75rem 1.5rem 2rem 1.5rem;
      max-width: 30.5rem;
      flex-shrink: 0;
    }

    ${desktop} {
      padding: 7.5rem 0 7.5rem 1rem;
    }
    ${sectionContainerWithPaddingBreakpoint} {
      padding-left: 0;
    }
  `,

  SubTitle: styled(MDSText.Subtitle)`
    margin: 1rem 0 0;
  `,

  Description: styled(MDSText.BodyRegDefault)`
    margin: 0;
  `,

  CategoryBadge: styled(Badge)`
    align-self: flex-start;
    background-color: rgba(255, 255, 255, 0.2);
    font-weight: 600;
    font-size: 1rem;
    color: ${(p) => p.theme.midwestColors.neutralDarkStrong};
  `,
};
